import styled from 'styled-components';
import {
    ArrowExpand,
    ArrowsShrinkIcon, CheckboxTickIcon,
    FilterIcon,
    LayeredSquaresIcon,
    PlusCircled,
    RoundPlusIcon,
    SquareMinusIcon
} from "assets/images";
import Scrollbars from "react-custom-scrollbars-2";
interface TickerDivProps {
    readonly isSelected: boolean;
}


export const TickersSelectWrapper = styled.div`
    display: flex;
    flex-direction: column;

    :nth-child(1) {
        border-right: 1px solid rgba(98, 147, 97, 0.15);
    }
    :nth-child(1) {
        border-radius: 10px 0 0 0;
        max-width: 250px;
    }
    :nth-child(2) {
        border-radius: 0 10px 0 0;
        width: 250px;
    }
`;

export const CustomPlusCircled = styled(PlusCircled)`
    cursor: pointer;
    height: 14px;
`;

export const CustomArrowExpand = styled(ArrowExpand)`
    cursor: pointer;
    height: 14px;
`;


export const CustomCheckboxTickIcon = styled(CheckboxTickIcon)`
    cursor: pointer;
    height: 14px;
    margin-right: 6px;
`;

export const ModalContentWrapper = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    box-shadow: 0 0 5px rgba(49, 69, 49, 0.14);
    border-radius: 10px;
    background-color: white;
`;


export const TopElementsDiv = styled.div`
    background-color: ${(props) => props.theme.bg.grey};
    height: 100px;
    padding: 10px 10px 0;
    border-bottom: 1px solid rgba(98, 147, 97, 0.15);

    :nth-child(1) {
        //border-radius: 10px 0 0 0;
    }

    :nth-child(2) {
        //border-radius: 0 10px 0 0;
    }
`;

export const TickersTitle = styled.div`
    margin: 0 0 10px;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;
export const TitleText = styled.span`
    flex-grow: 1;
`;

export const SelectDiv = styled(Scrollbars)`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
`;

export const TickerName = styled.span`
    //min-width:150px;
    //width: 75%;
    cursor: pointer;
    overflow: hidden;
    white-space:nowrap;
    text-overflow:ellipsis;
    display:inline-block;
    flex-grow: 1;

`;

export const CustomRoundPlusIcon = styled(RoundPlusIcon)`
    cursor: pointer;
`;

export const CustomSquareMinusIcon = styled(SquareMinusIcon)`
    cursor: pointer;
    margin-right: 3px;

`;
export const CustomArrowsShrinkIcon = styled(ArrowsShrinkIcon)`
    cursor: pointer;
    margin-right: 5px;
`;

export const CustomFilterIcon = styled(FilterIcon)`
    cursor: pointer;
`
export const CustomLayeredSquaresIcon = styled(LayeredSquaresIcon)`
    cursor: pointer;
    margin-right: 7px;
    :last-child {
        margin-right: 0;
    }
`

export const TickerItemDiv = styled.div<TickerDivProps>`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    height: 35px;
    padding: 0 10px 0 15px;
    border-bottom: 1px solid rgba(98, 147, 97, 0.15);
    position: relative;
    background: ${props => props["isSelected"] === true ?
        "rgba(98, 147, 97, 0.15)" : "transparent"};

    :hover {
        background: rgba(98, 147, 97, 0.15);
    }

`;








